@use "~theme/breakpoints";
.container {
    max-width: 100%;
    width: 100%;
    background: var(--white);
    border: 1px solid var(--blue-02);
    box-shadow: 0px 2px 6px var(--gray-03);
    border-radius: 4px;
    margin-top: 5px;
}

.headerSection {
    border-bottom: 0.5px solid var(--blue-02);
    height:35px;
    padding-top: 5px;
}

.heading {
    color: var(--blue-01);
    float: left;
    width:80%;
    padding: 1px 0px 0px 10px;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 16px;
    line-height: 150%;
    @include breakpoints.desktop {
        font-size: 12px; 
        width:74%;
    }
    @include breakpoints.desktop-medium {
        font-size: 14px; 
        width:80%;
    }
    @include breakpoints.desktop-medium {
        font-size: 16px; 
        width:80%;
    }
}

.action {
    color: var(--blue-01);
    float:right;
    width:20%;
    padding: 1px 10px 0px 0px;
    text-align: right;
    text-decoration: underline;
    font-weight: 400;
    font-size: 16px;
    line-height: 140%;
    align-items: center;
    text-align: right;
    letter-spacing: 0.02em;
    text-decoration-line: underline;
    text-transform: uppercase;
    color: var(--blue-01);
    cursor: pointer;
    @include breakpoints.desktop {
        font-size: 12px; 
        width:26%;
    }
    @include breakpoints.desktop-medium {
        font-size: 14px; 
        width:20%;
    }
    @include breakpoints.desktop-large {
        font-size: 16px; 
        width:20%;
    }
}

.contentSection {
    padding: 10px 10px 25px 10px;
    display: block;
    overflow: auto;
}

.contentLeft {
    float:left;
    width: 15%;
}

.vehcontentLeft {
    width: 22%;
}

.contentRight {
    float:right;
    width: 82%;
    text-align: left;
    margin-left: 10px;
    @include breakpoints.desktop {
        width:80%;
    }
    @include breakpoints.desktop-medium {
        width:80%;
    }
    @include breakpoints.desktop-large {
        width:82%;
    }
}
.vehcontentRight {
    width: 75%;
    @include breakpoints.desktop {
        width:70%;
    }
    @include breakpoints.desktop-medium {
        width:72%;
    }
    @include breakpoints.desktop-large {
        width:72%;
    }
}
.doctorName {
    font-weight: 600;
    font-size: 18px;
    line-height: 140%;
    letter-spacing: 0.02em;
    color: var(--black);
    @include breakpoints.desktop {
        font-size: 14px;
    }
    @include breakpoints.desktop-medium {
        font-size: 16px;
    }
}

.timeSlot {
    text-transform: uppercase;
    font-weight: 400;
    font-size: 14px;
    line-height: 140%;
    letter-spacing: 0.02em;
    color: var(--black);
    @include breakpoints.desktop {
        font-size: 12px;
    }
    @include breakpoints.desktop-medium {
        font-size: 13px;
    }
    @include breakpoints.desktop-large {
        font-size: 14px;
    }
}

.moveTop {
    top: 46%;
}

.retiringSection{
    padding: 10px 10px 10px 10px;
}